import { createAction } from '@reduxjs/toolkit';
import { IResource } from '../../../../dto';
import { ACT_SET, MN_RESOURCES, TYPE_ELEMENT } from '../../../../common';

export const setResource = createAction<IResource>(
  `${MN_RESOURCES}/${TYPE_ELEMENT}/${ACT_SET}`,
);
